/**
 * Electron App API wrapper
 *
 * Provides typed wrappers for app-level Electron IPC calls.
 * IMPORTANT: Keep in sync with projects/electron/src/preload.ts
 */

export function onUpdateAvailable(callback: () => void): () => void {
    if (!window.wildlarkAPI) return () => {}
    return window.wildlarkAPI.app.onUpdateAvailable(callback)
}

export function onUpdateError(callback: () => void): () => void {
    if (!window.wildlarkAPI) return () => {}
    return window.wildlarkAPI.app.onUpdateError(callback)
}

export async function applyUpdate(): Promise<void> {
    if (!window.wildlarkAPI) return
    await window.wildlarkAPI.app.applyUpdate()
}

export async function retryUpdateCheck(): Promise<void> {
    if (!window.wildlarkAPI) return
    await window.wildlarkAPI.app.retryUpdateCheck()
}

export async function setTerminalKeyboardCapture(captured: boolean): Promise<void> {
    if (!window.wildlarkAPI) return
    await window.wildlarkAPI.app.setTerminalKeyboardCapture(captured)
}
